import { AddOutlined as AddOutlinedIcon, Clear, Search } from "@mui/icons-material";
import {
	Box,
	Button,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	SelectChangeEvent,
	TextField,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import React from "react";

interface ToolbarListagemContratosProps {
	searchText: string;
	status: string;
	dataCreate: string;
	isSearching: boolean;

	onChangeSearchText: (value: string) => void;
	onChangeStatus: (value: string) => void;
	onChangeDataCreate: (value: string) => void;

	onSearch: () => void;
	onClearSearch: () => void;

	showButtonNew?: boolean;
	onClickNew?: () => void;
	isButtonNewDisabled?: boolean;
}

export const ToolbarListagemContratos: React.FC<ToolbarListagemContratosProps> = ({
	searchText,
	status,
	dataCreate,
	isSearching,
	onChangeSearchText,
	onChangeStatus,
	onChangeDataCreate,
	onSearch,
	onClearSearch,
	showButtonNew = true,
	onClickNew,
	isButtonNewDisabled,
}) => {
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

	const handleChangeStatus = (event: SelectChangeEvent) => {
		onChangeStatus(event.target.value as string);
	};

	return (
		<Box component={Paper} display="flex" flexDirection="column" padding={2} gap={1} mx={1} elevation={0}>
			{/* Linha 1: filtros + botão novo */}
			<Grid container spacing={2} direction={isSmallScreen ? "column" : "row"} alignItems={isSmallScreen ? "stretch" : "center"}>

				<Grid item xs={12} sm={6} md={3}>
					<FormControl fullWidth size="small">
						<InputLabel id="status-contratos">Status</InputLabel>
						<Select labelId="status-contratos" label="Status" value={status || "Todos"} onChange={handleChangeStatus}>
							<MenuItem value="Todos">Todos</MenuItem>
							<MenuItem value="active">Ativo</MenuItem>
							<MenuItem value="inactive">Inativo</MenuItem>
							<MenuItem value="canceled">Cancelado</MenuItem>
							<MenuItem value="blocked">Bloqueado</MenuItem>
							<MenuItem value="sent">Enviado</MenuItem>
						</Select>
					</FormControl>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<TextField
						fullWidth
						size="small"
						label="Data de cadastro"
						type="date"
						InputLabelProps={{ shrink: true }}
						value={dataCreate}
						onChange={(e) => onChangeDataCreate(e.target.value)}
					/>
				</Grid>

				{showButtonNew && (
					<Grid item xs={12} sm="auto" md="auto" sx={{ ml: { md: "auto" } }}>
						<Button variant="contained" color="primary" startIcon={<AddOutlinedIcon />} onClick={onClickNew} disabled={isButtonNewDisabled}>
							Novo
						</Button>
					</Grid>
				)}
			</Grid>

			{/* Linha 2: pesquisa + botão pesquisar ao lado */}
			<Grid container spacing={2} direction={isSmallScreen ? "column" : "row"} alignItems={isSmallScreen ? "stretch" : "center"}>
				<Grid item xs={12} sm={6} md={4} sx={{ maxWidth: { md: 520 } }}>
					<TextField
						fullWidth
						size="small"
						placeholder="Pesquisar..."
						value={searchText}
						onChange={(e) => onChangeSearchText(e.target.value)}
						InputProps={{
							startAdornment: (
								<IconButton aria-label="Pesquisar" edge="start" size="small" disabled>
									<Search />
								</IconButton>
							),
							endAdornment: (
								<IconButton
									aria-label="Limpar pesquisa"
									onClick={() => {
										onClearSearch();
										onChangeSearchText("");
									}}
									edge="end"
									size="small"
								>
									<Clear />
								</IconButton>
							),
						}}
					/>
				</Grid>
				<Grid item xs={12} sm="auto" md="auto">
					<Button
						variant="contained"
						color="primary"
						startIcon={<Search />}
						onClick={onSearch}
						disabled={isSearching}
						sx={{ textTransform: "none" }}
					>
						Pesquisar
					</Button>
				</Grid>
			</Grid>
		</Box>
	);
};
